import React, { Fragment } from 'react';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import IconButton from '@mui/material/IconButton';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import Divider from '@mui/material/Divider';

function Networking() {
  const [numberOfNetworking, setNumberOfNetworking] = React.useState<number>(1);

  return (
    <Paper
      elevation={0}
      sx={{
        display: 'block',
        padding: '0px 24px 20px 24px',
        maxWidth: '650px',
        minWidth: '300px',
      }}
    >
      <Grid container rowSpacing={2} columnSpacing={4}>
        <Grid item xs={12}>
          <Typography fontSize='0.9rem' fontWeight='bold'>
            9 Vernetzung/Kooperation mit anderen Stellen (bitte benennen)
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <Divider sx={{ borderBottomWidth: 2, borderColor: '#000000' }} />
          <Typography fontSize='0.75rem'>
            <b>Hinweis:</b> Gemeint ist die fallunabhängige Vernetzung/Kooperation mit anderen Stellen oder Gremien.
          </Typography>
          <Divider sx={{ borderBottomWidth: 2, borderColor: '#000000' }} />
        </Grid>
        <Grid item xs={9}></Grid>
        <Grid item xs={3}>
          <IconButton
            size='small'
            onClick={() => {
              setNumberOfNetworking(numberOfNetworking + 1);
            }}
          >
            <AddCircleIcon fontSize='large' color='primary' />
          </IconButton>
        </Grid>
        <Grid item xs={7}>
          <Typography fontSize='0.9rem'>Bezeichnung</Typography>
        </Grid>
        <Grid item xs={5}>
          <Typography fontSize='0.9rem'>Anzahl</Typography>
        </Grid>
      </Grid>
      <Grid container rowSpacing={2} columnSpacing={4} mt={1} className='fhbf-print-field-text-right'>
        {Array(numberOfNetworking)
          .fill(0)
          .map((_, index) => (
            <Fragment key={`networking_${index}`}>
              <Grid item xs={9}>
                <TextField label='' variant='standard' fullWidth />
              </Grid>
              <Grid item xs={3}>
                <TextField label='' variant='standard' fullWidth />
              </Grid>
            </Fragment>
          ))}
      </Grid>
    </Paper>
  );
}

export default Networking;
